import { CSSProperties } from 'react';

import { TColumnsSectionBlockProps } from '../types';

const px = (v: number) => `${v}px`;

export function getPaddingBefore(index: number, blockProps: TColumnsSectionBlockProps) {
  if (index === 0) {
    return '0';
  }
  if (blockProps.columnsCount === 2) {
    return px(blockProps.columnGap / 2);
  }
  if (index === 1) {
    return px(blockProps.columnGap / 3);
  }
  return px((2 * blockProps.columnGap) / 3);
}

export function getPaddingAfter(index: number, blockProps: TColumnsSectionBlockProps) {
  const { columnsCount, columnGap } = blockProps;
  if (columnsCount === 2) {
    if (index === 0) {
      return px(columnGap / 2);
    }
    return '0';
  }

  if (index === 0) {
    return px((2 * columnGap) / 3);
  }
  if (index === 1) {
    return px(columnGap / 3);
  }
  return '0';
}

function toColumnPercentage(num: number) {
  return `${100 / (12 / num)}%`;
}

export function getBlockWidth(index: number, blockProps: TColumnsSectionBlockProps): CSSProperties['width'] {
  const { columnsCount, dimensionsRule, columnGridDimensions, fixedWidths } = blockProps;
  if (dimensionsRule === 'manual') {
    const value = fixedWidths[index];
    return typeof value === 'number' ? value : undefined;
  }

  if (columnsCount === 2) {
    if (index === 0) {
      return toColumnPercentage(columnGridDimensions[0]);
    }
    return toColumnPercentage(12 - columnGridDimensions[0]);
  }

  if (index === 0) {
    return toColumnPercentage(columnGridDimensions[0]);
  }
  const secondValue = columnGridDimensions[1] || 8;
  if (index === 1) {
    return toColumnPercentage(secondValue - columnGridDimensions[0]);
  }
  return toColumnPercentage(12 - secondValue);
}
